import Header from "../../components/public/header";
import Navigation from "../../components/public/navigation";
import Main from "../../components/public/sections/main";
import Computer from "../../components/public/computer";
import Footer from "../../components/public/footer";

export default () => {
  return (
    <>
      <Navigation />
      <Header />
      <Main pageHeading={"संगणक संस्था"} content={<Computer />} />
      <Footer />
    </>
  );
};
